import { render } from "./Mil.vue?vue&type=template&id=bc5f3eee"
import script from "./Mil.vue?vue&type=script&lang=js"
export * from "./Mil.vue?vue&type=script&lang=js"

import "./Mil.vue?vue&type=style&index=0&id=bc5f3eee&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__